import { Link } from 'react-router-dom';
import { categoriesData } from '@/mocks/categoryData';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/70">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            内容分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按照您的需求浏览不同分类的内容，快速找到所需信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categoriesData.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300/60 hover:shadow-sm transition-all duration-300 cursor-pointer flex flex-col items-center text-center"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${category.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 font-heading">{category.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{category.description}</p>
              <span className="mt-4 text-xs font-medium text-primary-600 flex items-center gap-1 whitespace-nowrap">
                浏览分类 <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}